import Backbone from 'backbone'
import Request from '../helpers/request'

const SchoolModel = Backbone.Model.extend({
    defaults: {
        id: null,
        name: null,
        pin: null,
        user_id: null,
    },
    update(name) {
        return Request({
            url: '/api/school',
            method: 'PUT',
            data: {
                name: name,
            },
        })
            .then((response) => {
                this.set('name', response.school.name)
                this.parent.localSave()
            })
    },
    create(name) {
        return Request({
            url: '/api/school',
            method: 'POST',
            data: {
                name: name,
            }
        })
            .then((response) => {
                // set the school data
                this.set({
                    id: response.school._id,
                    name: response.school.name,
                    pin: response.school.pin,
                })

                // update the current user policy to super admin
                this.parent.get('role').set('name', response.user.role)
                this.parent.localSave()
            })
    },
    join(pin) {
        return Request({
            url: '/api/me/school/join',
            method: 'POST',
            data: {
                pin: pin,
            }
        })
            .then((response) => {
                this.set('id', response.school._id)
                this.parent.get('type').set('name', response.user.type)
                this.parent.localSave()

                return response.school.name
            })
    },
    resetPin() {
        return Request({
            url: '/api/school/pin',
            method: 'PUT',
            data: {}
        })
            .then((response) => {
                this.set('pin', response.school.pin)
                this.parent.localSave()
            })
    }
})

export default SchoolModel
